import React from 'react';
import { KatDataTable } from '@amzn/katal-react';
import { PCFormatter } from './PCFormatter';
import { WarehouseGSLAEntry } from '../../types/bulkGslaTypes';

interface GSLADataTableProps {
    columns: any[];
    data: WarehouseGSLAEntry[];
    tableRef: React.RefObject<any>;
}

export const GSLADataTable: React.FC<GSLADataTableProps> = ({
    columns,
    data,
    tableRef
}) => {
    return (
        <KatDataTable 
            id={'gslaDataTable'} 
            columns={columns} 
            rowData={data} 
            ref={tableRef}
        />
    );
};